import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmployerContact } from '../../../../models/employers/employer-contact';
import { BaseButtonSizeEnum } from '../base-button/base-button-size.enum';

@Component({
  selector: 'app-employer-record-contacts-section',
  templateUrl: './employer-record-contacts-section.component.html',
  styleUrls: ['./employer-record-contacts-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordContactsSectionComponent {
  @Input({ required: true }) primaryContact!: EmployerContact;
  @Input() additionalContacts: EmployerContact[] = [];
  @Output() editContactsClicked = new EventEmitter();

  public additionalContactsExpandedState: { [key: number]: boolean } = {};

  public primaryContactCollapseState = true;

  public onCardToggle(contact?: EmployerContact): void {
    if (contact?.id) {
      this.additionalContactsExpandedState = {
        ...this.additionalContactsExpandedState,
        [contact.id]: !this.additionalContactsExpandedState[contact.id]
      };
    }
  }

  public expandAll(): void {
    this.additionalContacts.forEach(contact => {
      this.additionalContactsExpandedState[contact.id] = true;
    });
    this.additionalContactsExpandedState = { ...this.additionalContactsExpandedState };
  }

  public collapseAll(): void {
    this.additionalContactsExpandedState = {};
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
